// removed by extract-text-webpack-plugin
module.exports = {"sub-header":"_2qbc2UYqtrWLOf_hilSEX5","faq":"_1audRqONxSDTy1KyBkS6xk","faq-detail-container":"_18vb6RXiuLjXdCQXTTHoM_","faq-label-container":"_1JDZsNwVnCLcSUc-_1SWhl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/Faq.scss
// module id = 1230
// module chunks = 0